import React from 'react';
import styles from './ProductInfo.css';
import RefillCountDisplay from './RefillCountDisplay';

const ProductInfo = ({
  imgSrc,
  productName,
  price,
  strength,
  flavorName,
  quantity,
  packageQtyDisplay,
  refillsRemaining,
  totalRefills,
}) => ({
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img className={styles.prescriptionImage} src={imgSrc} alt="" />
        </div>
        <div className={styles.prescriptionData}>
          <h1 className={styles.drugName}>{productName}</h1>
          <span className={styles.price}>${price.toFixed(2)}</span>
          <span>{strength}</span>
          {String(packageQtyDisplay) !== '1' ? (
            <span className={styles.titleCase}>{packageQtyDisplay}</span>
          ) : (
            ''
          )}
          {String(quantity) !== '1' ? <span>Qty: {quantity}</span> : ''}
          {String(flavorName) !== 'null' ? (
            <span className={styles.titleCase}>Flavor: {flavorName}</span>
          ) : (
            ''
          )}
          {refillsRemaining <= 0 ? null : (
            <RefillCountDisplay
              refillsRemaining={refillsRemaining}
              totalRefills={totalRefills}
            />
          )}
        </div>
      </div>
    );
  },
});

export default ProductInfo;



// WEBPACK FOOTER //
// ./src/containers/CartPage/ProductInfo.jsx